import { PmNodeType } from "@storytell/types/richText";
import { Node, type NodeViewProps } from "@tiptap/core";
import type { JSX } from "solid-js";
import { Dynamic } from "solid-js/web";
import { NodeViewWrapper, SolidNodeViewRenderer } from "tiptap-solid";

export type CitationNodeProps = NodeViewProps & {
  node: { attrs: { value: string } };
};
export const CitationExtension = (opts: {
  renderer: (props: CitationNodeProps) => JSX.Element;
}) =>
  Node.create({
    name: PmNodeType.Citation,
    group: "inline",
    inline: true,
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        value: "",
      };
    },

    renderText({ node }) {
      return `<cite>${node.attrs.value}</cite>`;
    },

    renderHTML({ node, HTMLAttributes }) {
      return ["cite", HTMLAttributes, node.attrs.value];
    },

    parseHTML() {
      return [
        {
          tag: "cite",
          getAttrs: (element: HTMLElement) => ({ value: element.textContent }),
        },
      ];
    },

    addNodeView() {
      return SolidNodeViewRenderer((props: CitationNodeProps) => (
        <NodeViewWrapper as={"span"}>
          <Dynamic component={opts.renderer} {...props} />
        </NodeViewWrapper>
      ));
    },
  });
